import { join } from '@pes-ui/utils';
export const getCurrentReference = (hasNodes, basePathSegment, url, isPbs) => {
  var _a, _b;
  const referenceUrl = isPbs ? url : window.location.pathname;
  const references = (_b = (_a = referenceUrl === null || referenceUrl === void 0 ? void 0 : referenceUrl.split(basePathSegment)[1]) === null || _a === void 0 ? void 0 : _a.split('/')) === null || _b === void 0 ? void 0 : _b.filter((pathSegment) => pathSegment !== '');
  if (!hasNodes) {
    return references ? references[0] : '';
  }
  return references.length > 1 ? references[1] : references[0];
};
export const getRangeNodesIds = (pathname, rangeReference) => {
  const decodedPathname = window.decodeURI(pathname);
  const decodedRangeReference = window.decodeURI(rangeReference);
  const position = decodedPathname.indexOf(decodedRangeReference);
  const rangePath = pathname.substr(position);
  const pathSegments = rangePath.split('/').filter((pathSegment) => pathSegment !== '');
  const rangeIdDisplayName = pathSegments[0];
  return {
    rangePath,
    rangeId: rangeIdDisplayName.split('-')[0],
    rangeIdDisplayName,
    nodeIdDisplayName: pathSegments.length >= 2 ? pathSegments[1] : '',
    nodeId: pathSegments.length >= 2 ? pathSegments[1].split('-')[0] : '',
    categoryIdDisplayName: pathSegments.length === 3 ? pathSegments[2] : '',
    categoryId: pathSegments.length === 3 ? pathSegments[2].split('-')[0] : '',
  };
};
const getRangeNode = (rangeUrl) => (node) => ({
  id: node.id,
  image: node.image,
  name: node.name,
  url: join(rangeUrl, `${node.nodeReference}/`),
  nodeReference: node.nodeReference,
  nodes: node.nodes,
  navigationState: node.navigationState,
});
export const calculateCurrentNodeParams = (node, rangeUrl, currentReference, backLabel, prevUrl, prevTitle) => {
  var _a, _b, _c;
  const currentNodeUrl = node.id === 'root' ? rangeUrl : join(rangeUrl, `${node.nodeReference}/`);
  if (node.nodeReference === currentReference && node.id === 'root') {
    return ((_a = node.nodes) === null || _a === void 0 ? void 0 : _a.length)
      ? {
        levelTitle: node.name,
        childrenNodes: node.nodes.map(getRangeNode(rangeUrl)),
        currentNodeUrl,
        showNodes: true,
        showProducts: false,
        navigationState: node.navigationState,
      }
      : {
        currentNodeUrl,
        showNodes: false,
        showProducts: true,
        navigationState: node.navigationState,
      };
  }
  if (node.nodeReference === currentReference) {
    return {
      backUrl: prevUrl,
      backUrlTitle: prevTitle,
      levelTitle: node.name,
      childrenNodes: node.nodes.map(getRangeNode(rangeUrl)),
      navigationState: node.navigationState,
      id: node.id,
      currentNodeUrl,
      showNodes: true,
      showProducts: ((_b = node.nodes) === null || _b === void 0 ? void 0 : _b.length) === 0,
    };
  }
  let foundNode;
  (_c = node.nodes) === null || _c === void 0 ? void 0 : _c.find((childNode) => {
    var _a;
    foundNode = calculateCurrentNodeParams(childNode, rangeUrl, currentReference, backLabel, currentNodeUrl, ((_a = childNode.nodes) === null || _a === void 0 ? void 0 : _a.length) ? node.name : backLabel);
    return foundNode.showNodes;
  });
  if (foundNode) {
    return foundNode;
  }
  return {
    currentNodeUrl,
    showNodes: false,
    showProducts: true,
  };
};
